/* Thai Herb House — th.js = mock/th.FROZEN.js + port patches P1-P4 (port/make_theme_assets.py). Vanilla, no deps.
   Reveal (IO + top<0 + rAF sweep, once) · motif parallax · drawer · mega hover · snap rows · tabs · accordions · header state. */
(function () {
  var d = document; d.documentElement.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reveal: plain descendant query (LAW §6), once
  var targets = Array.prototype.slice.call(d.querySelectorAll('[data-th-reveal]'));
  function show(el) { if (!el.classList.contains('is-in')) el.classList.add('is-in'); }
  var design = !!(window.Shopify && window.Shopify.designMode);
  if (design) d.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-th-reveal]').forEach(show); });
  if (reduce) { targets.forEach(show); }
  else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting || en.boundingClientRect.top < 0) { show(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    targets.forEach(function (t) { io.observe(t); });
    var ticking = false;
    function sweep() {
      ticking = false; var h = window.innerHeight;
      targets.forEach(function (t) { if (t.classList.contains('is-in')) return; var r = t.getBoundingClientRect(); if (r.top < h * 0.9 || r.bottom < 0) show(t); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }, { passive: true });
    window.addEventListener('load', sweep);
  }

  // parallax on the large motif shapes (0.08–0.12, transform only)
  var px = Array.prototype.slice.call(d.querySelectorAll('[data-th-parallax]'));
  if (px.length && !reduce && window.innerWidth > 767) {
    var pt = false;
    function para() {
      pt = false; var h = window.innerHeight;
      px.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.bottom < -200 || r.top > h + 200) return;
        var c = (r.top + r.height / 2) - h / 2; var s = parseFloat(el.getAttribute('data-th-parallax')) || 0.1;
        el.style.transform = 'translate3d(0,' + (-c * s).toFixed(1) + 'px,0) rotate(var(--rot,0deg))';
      });
    }
    window.addEventListener('scroll', function () { if (!pt) { pt = true; requestAnimationFrame(para); } }, { passive: true });
    para();
  }

  // header: solid after 8px; mega menus on hover (desktop) and on click (touch)
  var hd = d.querySelector('.th-header');
  if (hd) {
    var solid = hd.hasAttribute('data-th-solid'); var onScroll = function () { hd.classList.toggle('is-scrolled', solid || window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    d.querySelectorAll('.th-nav > li').forEach(function (li) {
      var a = li.querySelector('.th-nav__a'); var mega = li.querySelector('.th-mega'); if (!mega) return;
      a.addEventListener('click', function (e) { if (window.matchMedia('(hover:none)').matches) { e.preventDefault(); li.classList.toggle('is-open'); } });
    });
  }

  // drawer
  var drawer = d.querySelector('.th-drawer');
  d.querySelectorAll('[data-th-drawer]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.getAttribute('data-th-drawer') === 'open';
      if (!drawer) return; drawer.classList.toggle('is-open', open); drawer.setAttribute('aria-hidden', open ? 'false' : 'true'); d.body.style.overflow = open ? 'hidden' : '';
    });
  });
  d.querySelectorAll('.th-drawer__group > button').forEach(function (b) { b.addEventListener('click', function () { b.parentNode.classList.toggle('is-open'); }); });

  // snap rows: native overflow-x + scroll-snap, arrows + n / N counter
  d.querySelectorAll('[data-th-row]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-th-track]'); var items = track.children; var out = wrap.querySelector('output');
    var prev = wrap.querySelector('[data-th-prev]'); var next = wrap.querySelector('[data-th-next]');
    var pad = function () { return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0; };
    function idx() { if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) return items.length - 1; var x = track.scrollLeft + 1, p = pad(); var i = 0; for (var k = 0; k < items.length; k++) { if (items[k].offsetLeft - track.offsetLeft - p <= x) i = k; } return i; }
    function upd() { if (out) out.value = (idx() + 1) + ' / ' + items.length; }
    function go(n) { var i = Math.max(0, Math.min(items.length - 1, idx() + n)); track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft - pad(), behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); upd();
  });

  // product tabs: filter cards by data-tag; "All" = the 12 featured (data-feat); hidden cards leave the grid (no jump)
  d.querySelectorAll('[data-th-tabs]').forEach(function (tabs) {
    var grid = tabs.closest('section').querySelector('[data-th-tabgrid]');
    tabs.querySelectorAll('[data-th-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        var k = t.getAttribute('data-th-tab');
        tabs.querySelectorAll('[data-th-tab]').forEach(function (o) { o.classList.toggle('is-on', o === t); o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
        var n = 0;
        grid.querySelectorAll('.th-card').forEach(function (c) { var on = k === 'all' ? c.hasAttribute('data-feat') : (c.getAttribute('data-tag') || '').split(' ').indexOf(k) > -1; c.classList.toggle('is-off', !on); if (on) { c.classList.remove('is-in'); c.style.setProperty('--i', n++ % 4); requestAnimationFrame(function () { c.classList.add('is-in'); }); } });
      });
    });
  });

  // herb cards: More / Less on phones (port P6)
  var herbs = Array.prototype.slice.call(d.querySelectorAll('.th-herb'));
  function herbFit() { herbs.forEach(function (c) { var p = c.querySelector('p'), b = c.querySelector('.th-herb__more'); if (!p || !b || c.classList.contains('is-open')) return; b.hidden = !(window.innerWidth <= 767 && p.scrollHeight > p.clientHeight + 1); }); }
  herbs.forEach(function (c) { var b = c.querySelector('.th-herb__more'); if (!b) return; b.addEventListener('click', function () { var open = !c.classList.contains('is-open'); c.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false'); }); });
  herbFit(); window.addEventListener('load', herbFit); window.addEventListener('resize', function () { requestAnimationFrame(herbFit); });

  // footer accordions on phones
  d.querySelectorAll('.th-footer__col > b').forEach(function (h) {
    h.addEventListener('click', function () { if (window.innerWidth > 767) return; h.parentNode.classList.toggle('is-open'); });
  });

})();
